import DealTables from './DealTables';

export default DealTables;
